import { Component, Inject, ViewEncapsulation, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { statusSchedule } from 'app/core/data/calendar.json';
import { scheduleI, scheduleStatus, openingHourI, rescheduleI } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { MAT_DATE_LOCALE} from '@angular/material/core';
import {MatCalendarCellClassFunction} from '@angular/material/datepicker';
import { addressI } from 'app/core/interfaces/adress';
import { organizationI } from 'app/core/interfaces/organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { encounterI } from 'app/core/interfaces/encounter';

@Component({
  selector: 'page-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.scss'],
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}],
  encapsulation: ViewEncapsulation.None
})
export class ScheduleDetailsComponent extends BaseComponent implements OnInit {

  public mock: scheduleI[] = [];
  public status = "planned";
  public horariosExame = 10;
  public horariosConsulta = 10;
  public scheduleStatus:scheduleStatus[] = statusSchedule;
  public schedule: scheduleI = <scheduleI>{};
  public encounter: encounterI = <encounterI>{};
  public titleDados = "Dados do Paciente";
  public titleReschedule = "Reagendamento";
  public scheduleHorarios: any[] = [];
  public address:addressI = <addressI>{};
  public organization: any =  <organizationI>{};
  public hours: any[] = []; 
  public dates: any[] = [];
  public hour: rescheduleI = <rescheduleI>{};

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector 
  ) { 
    super(injector);
  }
  
  myFilter = (d: Date | null): boolean => {
    const date = moment(d).format('YYYY-MM-DD');
    const time = moment(d).format('HH:MM');
    // Prevent Saturday and Sunday from being selected.  
    return true;
  };


  ngOnInit(): void {
    this.getOrganizationTime();
    if (this.data.param.id) {
      this.getScheduleDetails(this.data.param.id);
    }
  }

  getScheduleDetails(id: number) {
    //@TODO GET schedule details
    //temporario localstorage
    this.schedule = this.auth.getFromLocalStorage('schedules').find((item:scheduleI) => item.id == this.data.param.id);
    if (this.schedule) {
      this.status = this.schedule.status ? this.schedule.status : "planned";
      this.organization = this.auth.getFromLocalStorage('organizations').find((item:organizationI)=> (this.schedule?.organization || 1) == item.id)
    //  this.address = this.organization.address;
    }
  }

  getOrganizationTime() {
    //@TODO GET schedule time
    this.scheduleHorarios = this.auth.getFromLocalStorage('organizations').find((item: organizationI) => item.id == 1).schedule;
  }

  reagendamento() {
    const schedule = this.schedule;
    if (!this.hour.date || !this.hour.time) {
        return;
    }   
    this.layout.openDialog({
      showButtonCancel: true,
      buttonText: 'salvar',
      title: 'Confirmar reagendamento',
      content: `Deseja reagendar o atendimento para <b>${moment(this.hour.date).format('DD/MM/YYYY')} ${this.hour.time}</b>?`
    }).subscribe((retorno: any) => {
      if (retorno) {
        schedule.dateStart = moment(this.hour.date).format('YYYY-MM-DD') + ' ' + this.hour.time;     
        //@TODO PUT validar data e reagendar atendimento
        //temporario altera localstorage    
        this.auth.updateLocalStorageById('schedules', this.schedule.id as number, this.schedule);    
        this.dialogRef.close();
      }
    });  
    this.schedule = schedule;
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const date = cellDate.getDate();
      // Highlight the 1st and 20th day of each month.
      return date === 1 || date === 20 ? 'warning-date' : '';
    }

    return '';
  };

  public cancelSchedule() { 
    let text = '<b>Exame/Consulta:</b> ';
    if (this.schedule?.procedure) {
      text += this.schedule.procedure.name;
    }
    if (this.schedule?.organization) {
      text += ` (${this.auth.getFromLocalStorage('organizations').find((item: organizationI) => (this.schedule?.organization||1) == item.id).name})`;
    }
    text += `<br/><b>Data/Hora:</b> ${this.layout.dateTimeFormat(this.schedule?.dateStart)}`;
    this.layout.openDialog({
      showButtonCancel: true,
      buttonText: 'Cancelar atendimento',
      title: 'Deseja cancelar o atendimento?',
      content: text
    }).subscribe((retorno: any) => {
      if (retorno) {
        this.removeSchedule();
        this.dialogRef.close();
      }
    })          
  }  
  public removeSchedule() {
    //@TODO chamar rotina para remover
    if (this.schedule) {
      this.auth.removeFromLocaStorageMock('schedules',this.schedule.id as number);
    }    
    this.dialogRef.close();
  }

  saveDiagnosis(){
    //TODO PUT to save diagnosis
  }

  getSlots(dayOfWeek: number) {
    //@TODO GET free slots
    this.hours = this.getHoursFromOrganization(1, dayOfWeek);
  }

  loadHours(selectedDate: string) {
    const dayOfWeek = moment(selectedDate).weekday();
    //@TODO GET as horas disponíveis no dia selecionado
    this.getSlots(1);  
  }
}
